import baseUrl from "../energyApiHost";
import { callApi } from "./util";

const getDevice = deviceId => {
  const url = `${baseUrl}devices/${deviceId}`;

  return callApi(url);
};

export default {
  getDevice
};
